import { AuthLayoutConfig } from '../../../shared/src/types/authLayout/types'
import logoUrlWhiteAsset from '../../../shared/src/assets/images/defaults/logoZingIEBT.png'
import sidebarTopLogoCollapsedAsset from '../../../shared/src/assets/images/defaults/zingSidebarLogoCollapsed.png'
import logoUrlWhiteNoLabelAsset from '../../../shared/src/assets/images/defaults/logoZingWhiteNoLabel.png'
import logoZingBlack from '../../../shared/src/assets/images/defaults/logoZingIEBTPreta.png'
import backgroundAuthAsset from '../../../shared/src/assets/images/defaults/backgroundAuth.png'

export const authLayout: AuthLayoutConfig = {
    logoUrl: logoUrlWhiteAsset,
    logoUrlWhite: logoUrlWhiteAsset,
    logoZingBlack: logoZingBlack,
    backgroundUrl: backgroundAuthAsset,
    variant: 'image',
    logoUrlWhiteNoLabel: logoUrlWhiteNoLabelAsset,
    sidebarTopLogoCollapsedUrl: sidebarTopLogoCollapsedAsset,
}
